enum MenuCoverPromoLinkType {
  NoLink = 'no-link',
  MenuItem = 'menu-item',
  MenuPage = 'menu-page',
  MenuSection = 'menu-section',
}

export { MenuCoverPromoLinkType };
